import { i18next, view } from '@yola/ws-sdk';
import displayOptionTypes from '../../constants/display-options-type';
import {
  CONTAINER_SELECTOR,
  CONTAINER_WIDTH_CLASS,
  CONTAINER_WIDTH_OPTION_ID,
  CONTAINER_WIDTH_PRESETS,
  CONTAINER_WIDTH_WIDE_PX,
} from '../../constants/container-width';

const defaultPreset = { value: CONTAINER_WIDTH_PRESETS.NARROW };

const presetForValue = (val) => {
  if (!val) return defaultPreset;
  if (val === `${CONTAINER_WIDTH_WIDE_PX}px`) return { value: CONTAINER_WIDTH_PRESETS.WIDE };
  if (val === '100%') return { value: CONTAINER_WIDTH_PRESETS.FILL };
  const n = parseInt(val, 10);
  if (Number.isFinite(n)) return { value: CONTAINER_WIDTH_PRESETS.CUSTOM, customValue: n };
  return defaultPreset;
};

const buildContainerWidthOption = ({ blockNode }) => {
  const classValue = view.accessors.getResponsiveClassValue({
    element: blockNode,
    className: CONTAINER_WIDTH_CLASS,
  });
  const { value, customValue = null } = presetForValue(classValue?.value);

  return {
    id: CONTAINER_WIDTH_OPTION_ID,
    type: displayOptionTypes.CONTAINER_WIDTH,
    querySelector: CONTAINER_SELECTOR,
    value,
    customValue,
    initialValue: value,
    initialCustomValue: customValue,
    title: i18next.t('Container width'),
  };
};

export default buildContainerWidthOption;
